import React, { useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import MainLayout from 'components/Layouts/MainLayout';
import { MachineHeader } from 'components/MachineHeader';
import { LanguageModal } from 'components/LanguageModal';
import Routes from 'lib/utils/routes';
import { getMachine } from 'lib/selectors/getMachine';
import { getOpenTraining } from 'lib/selectors/getOpenTraining';

import { DowntimePopup } from 'components/DowntimePopup';
import { WorkflowPopup } from 'components/WorkflowPopup';
import { MessagePopup } from 'components/MessagePopup';
import { TrainingDoc } from 'components/TrainingDoc';
import { getHomeTab } from 'lib/selectors/getTabs';
import { actionCloseLanguageModal } from 'lib/actions';
import { getLanguageModalOpen } from 'lib/selectors/getLanguageModalOpen';
import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';
import { ControlActionModal } from './ControlActionModal';
import { ERPJobControlBar } from './ERPJobControlBar';
import { DefaultJobControlBar } from './DefaultJobControlBar';
import MachineMainWrapper from './MachineMainWrapper';

const Page = () => {
  const dispatch = useDispatch();

  const isJobLaborTrackingEnabled = useSelector(getIsJobLaborTrackingEnabled);

  const openTraining = useSelector(getOpenTraining);
  const machine = useSelector(getMachine);
  const homeTab = useSelector(getHomeTab);

  const [controlAction, setControlAction] = useState(null);

  const languageModalOpen = useSelector(getLanguageModalOpen);

  if (openTraining) {
    return <TrainingDoc />;
  }

  return (
    <>
      <Route exact path={Routes.machineIdHomePath.pattern}>
        <Redirect to={Routes.machineIdHomeTabPath(machine.id, homeTab)} />
      </Route>
      <Route
        path={Routes.machineIdHomeTabPath.pattern}
        render={({
          match: {
            params: { tab },
          },
        }) => {
          return (
            <>
              <WorkflowPopup />
              <DowntimePopup />
              <MessagePopup />
              {controlAction && (
                <ControlActionModal
                  controlAction={controlAction}
                  setControlAction={setControlAction}
                />
              )}
              <LanguageModal
                isOpen={languageModalOpen}
                onClose={() => {
                  return dispatch(actionCloseLanguageModal());
                }}
              />
              <MainLayout.Container direction="column">
                <MachineHeader />
                <MainLayout.Container direction="column">
                  <MachineMainWrapper tab={tab} />
                </MainLayout.Container>

                {isJobLaborTrackingEnabled ? (
                  <ERPJobControlBar />
                ) : (
                  <DefaultJobControlBar setControlAction={setControlAction} />
                )}
              </MainLayout.Container>
            </>
          );
        }}
      />
    </>
  );
};

export default Page;
